import React, { useState } from "react";
import { Button } from "antd";
import "antd/dist/antd.css";
import "../../css/users.css";
import { useNavigate } from "react-router-dom";
import LeftSideNav from "../../components/LeftSideNav";
import { useVerifyTokenMutation } from "../../store/appSlice";
import OtpInput from "react18-input-otp";
import { isEmpty } from "lodash";

function VerificationCode() {
  const navigate = useNavigate();

  const [otp, setOpt] = useState("");
  const [otpError, setOptError] = useState("");

  const [verifyToken] = useVerifyTokenMutation();

  const validation = () => {
    if (isEmpty(otp)) {
      setOptError("Enter the otp sent to you on your email");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setOptError("");
    if (validation()) {
      // if (true) {
      const payload = {
        secretKey: otp,
      };

      verifyToken(payload)
        .unwrap()
        .then((incomingData: any) => {
          console.log({ incomingData });
          navigate("/auth/reset_password", {
            state: { uniqueKey: incomingData?.uniqueKey ?? "" },
          });
        })
        .catch((err) => {
          setOptError("Invalid OTP");
        });
    }
  };

  const inputFormView = () => (
    <div className="main-verification_code">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: "20%",
        }}
      >
        <div className="signin-form-div">
          <h2>Verify Otp</h2>
          <p>Enter the otp sent over your email</p>
          <div>
            <OtpInput
              value={otp}
              onChange={(e: string) => setOpt(e)}
              numInputs={6}
              isInputNum={false}
              inputStyle="otp-inputs"
              containerStyle="otp-container"
              separator={<span style={{ fontSize: "40px" }}>-</span>}
            />
            {!isEmpty(otpError) && (
              <div style={{ width: "450px", marginTop: -30, marginLeft: 10, marginBottom: 20 }}>
                <text style={{ color: "red" }}>{otpError}</text>
              </div>
            )}
          </div>

          <div style={{ marginTop: 20 }}>
            <Button
              type="primary"
              onClick={() => {
                handleSubmit();
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="login_container">
      <div className="left-nav-col">
        <LeftSideNav />
      </div>
      <div className="inputform_container">{inputFormView()}</div>
    </div>
  );
}

export default VerificationCode;
